import * as common from './common.json';

export const ms = {
  common,
};
